import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */
import { actions as companyActions } from 'sagas/app/companies/companySaga';
import { actions as departmentActions } from 'sagas/app/departments/departmentSaga';

/**
 * Constants
 */
export const REQUEST = '@app/company/edit/assignBMK/REQUEST';
export const SUCCESS = '@app/company/edit/assignBMK/SUCCESS';
export const FAILURE = '@app/company/edit/assignBMK/FAILURE';
export const CLEAR = '@app/company/edit/assignBMK/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    errorMessage: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.errorMessage = '';
                break;
            case SUCCESS:
                draft.loading = false;
                break;
            case FAILURE:
                draft.errorMessage = payload;
                break;
            case CLEAR:
                draft.loading = false;
                draft.errorMessage = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            const { company_id, isParent, ...body } = payload;
            const response = yield axios.put(`/companies/admin/${company_id}`, {
                ...body
            });

            if (isParent) {
                yield put(companyActions.changeBMK(response.data.data.admin));
            } else {
                yield put(departmentActions.changeBMK(response.data.data.admin));
            }
            yield put(actions.success());
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
